import React, { useCallback } from 'react'
import { Formik, Form } from 'formik'
import styled from 'styled-components'
import { useMutation } from 'graphql-hooks'
import { useHistory } from 'react-router-dom'

import Field from '../../atoms/Field'
import { Button } from '../../atoms/Button'

const initialValues = {
  email: '',
}

const RECOVER_MUTATION = `
  mutation RecoverPwd($email: String!) {
    forgotPassword(email: $email) {
      ok
    }
  }
`

function validate(values) {
  const errors = {}

  if (!values.email) {
    errors.email = 'Inserisci una mail'
  } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(values.email)) {
    errors.email = 'Inserisci una mail valida'
  }

  return errors
}

export default function RecoverPasswordForm() {
  const [doRecover] = useMutation(RECOVER_MUTATION)
  const history = useHistory()

  const onSubmit = useCallback(
    async (values) => {
      const res = await doRecover({
        variables: {
          email: values.email,
        },
      })

      if (res.error) {
        console.log(res.error)
      } else {
        history.push('/')
      }
    },
    [history, doRecover]
  )

  return (
    <Formik
      initialValues={initialValues}
      onSubmit={onSubmit}
      validateOnMount
      validate={validate}
    >
      {({ isSubmitting, isValid }) => (
        <Form>
          <Field
            name="email"
            type="email"
            label="Indirizzo Email"
            placeholder="La tua email"
          />

          <Footer>
            <Button
              as="input"
              type="submit"
              value="Recupera"
              disabled={isSubmitting || !isValid}
            />
          </Footer>
        </Form>
      )}
    </Formik>
  )
}

const Footer = styled.footer`
  margin-top: 32px;
`
